module.exports = __webpack_public_path__ + "static/media/bg.c4ac5603.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/bg.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/bg.jpeg
// module chunks = 0